import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
 
// For more options see below
Vue.use(VueReCaptcha, {
  siteKey: process.env.MIX_GOOGLE_RECAPTCHA_KEY,
  loaderOptions: {
    autoHideBadge: true
  }
})


// WEBPACK FOOTER //
// ./resources/js/plugins/recaptcha.js